import { roundNumberToTwoDecimals, BarChartTooltipItem } from '@occc/ui-design-system';
import { separateEveryThousandByComma } from '../../../../lib/numbers';

type BuildBarChartTooltipSurveyItems = {
  range: string;
  sum?: number;
  percentage: number;
};

export const buildBarChartTooltipSurveyItems = ({
  range,
  sum,
  percentage,
}: BuildBarChartTooltipSurveyItems): BarChartTooltipItem[] => {
  return [
    {
      label: `Responses in ${range}`,
      labelColor: (theme) => theme.palette.text.primary,
      labelVariant: 'subtitle1',
    },
    {
      label: 'Number of responses',
      value: typeof sum === 'number' ? separateEveryThousandByComma(sum) : '',
      labelVariant: 'body1',
      valueVariant: 'subtitle1',
    },
    {
      label: 'Cohort size',
      value: `${roundNumberToTwoDecimals(percentage)}%`,
      labelVariant: 'body1',
      valueVariant: 'subtitle1',
    },
  ];
};
